export const EXCEL_SPREADSHEET_TYPE =
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
